import './styles.scss';
import BenefitCard from './BenefitCard';
import YoutubeLink from 'components/YoutubeLink';

const BenefitsBox = ({ title, data }) => (
    <div className="box benefits-box">
        <h3>{title}</h3>
        <div className="benefits-container">
            {data.map((item, index) => (
                <BenefitCard key={index} item={item} index={index} />
            ))}
        </div>
        <YoutubeLink videoId="KPhzCco_ku4" />
    </div>
);

export default BenefitsBox;
